var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sui-popup",
    {
      attrs: {
        value: _vm.value,
        lockScroll: _vm.lockScroll,
        type: "center",
        "close-on-click-mask": false
      },
      on: {
        input: function($event) {
          return _vm.$emit("input", $event)
        }
      }
    },
    [
      _c("div", { staticClass: "sui-modal" }, [
        _c(
          "div",
          { staticClass: "sui-modal-header" },
          [
            _c("span", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _vm.showCloseIcon
              ? _c("sui-icon", {
                  staticClass: "sui-modal-close",
                  attrs: { type: "Arrowclose", color: "#CCCCCC", size: "16px" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onClose($event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "wrapClass",
                rawName: "v-wrapClass",
                value: "sui-modal-main--wrap",
                expression: "'sui-modal-main--wrap'"
              }
            ],
            staticClass: "sui-modal-main",
            class: _vm.textAlignClass
          },
          [
            _c(
              "span",
              { staticStyle: { "font-size": "13px" } },
              [_vm._t("default", [_vm._v(_vm._s(_vm.content))])],
              2
            )
          ]
        ),
        _vm._v(" "),
        _vm.btn && _vm.btnType === "normal"
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "touch-class",
                    rawName: "v-touch-class",
                    value: "sui-modal-footer--active",
                    expression: "'sui-modal-footer--active'"
                  }
                ],
                staticClass: "sui-modal-footer--normal",
                on: { click: _vm.onConfirm }
              },
              [_vm._v(_vm._s(_vm.btn))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.btn && _vm.btnType === "emphasize"
          ? _c(
              "div",
              { staticClass: "sui-modal-footer--emphasize" },
              [
                _c(
                  "sui-button",
                  { attrs: { size: "small" }, on: { click: _vm.onConfirm } },
                  [_vm._v(_vm._s(_vm.btn))]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.btnPrimary && _vm.btnEmphasize
          ? _c("div", { staticClass: "sui-modal-footer--gemini" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "touch-class",
                      rawName: "v-touch-class",
                      value: "sui-modal-footer--active",
                      expression: "'sui-modal-footer--active'"
                    }
                  ],
                  staticClass: "sui-modal-footer-btnPrimary",
                  on: { click: _vm.onCancel }
                },
                [_vm._v(_vm._s(_vm.btnPrimary))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "touch-class",
                      rawName: "v-touch-class",
                      value: "sui-modal-footer--active",
                      expression: "'sui-modal-footer--active'"
                    }
                  ],
                  staticClass: "sui-modal-footer-btnEmphasize",
                  on: { click: _vm.onConfirm }
                },
                [_vm._v(_vm._s(_vm.btnEmphasize))]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }